<template>
  <div>
    <el-table :data="detailsArr" :empty-text="$t('generic.noData')">
      <el-table-column type="expand">
        <template slot-scope="props">
          <emv-clearing-entry-details :details="props.row"/>
        </template>
      </el-table-column>
      <el-table-column
        v-for="column in tableColumns"
        :key="column.label"
        :min-width="column.minWidth"
        :width="column.width"
        :prop="column.prop"
        :label="column.label"
        :formatter="column.formatter"
      >
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {Table, TableColumn} from "element-ui";
import EmvClearingEntryDetails from "@/components/EmvClearingEntry/EmvClearingEntryDetails";

export default {

  name: "EmvClearingEntriesTable",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    EmvClearingEntryDetails
  },
  props: {
    detailsArr: {
      type: Array,
      required: true,
      description: 'all entries'
    },
  },
  methods: {},
  computed: {},
  data() {
    return {
      tableColumns: [
        {
          prop: 'journey_operation_ts',
          label: this.$t('emvClearingEntries.details.journey_operation_ts'),
          formatter: (row, column, cellValue, index) => {
            return this.$options.filters.time(cellValue)
          },
          minWidth: 80
        },
        {
          prop: 'amount',
          label: this.$t('emvClearingEntries.details.amount'),
          formatter: (row, column, cellValue, index) => {
            return this.$options.filters.money(cellValue)
          },
          minWidth: 80
        },
      ],
    };
  },
}
</script>

<style scoped>
</style>
